export default {
  loading: false,
  tags: [],
  tag: {},
  files: [],
  total: 0,
  form: {
    logistic_provider: null,
    delivery_methods: [],
    document_type: null,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/store/states.js